import { SchemaFormFactory } from 'formvuelate';
import VeeValidatePlugin from './VeeValidatePlugin';

import { setLocale } from 'yup';
import fr from '@/i18n/validation/fr';
setLocale(fr);

export const SchemaFormWithValidation = SchemaFormFactory([VeeValidatePlugin({})]);
